export const pdfRulesEvidenciasSeloEnum = {
  umArquivo: 1,
  umOuDoisArquivos: 2,
  qtdAtendInfoOuQtdDiagnostico: 3,
  ilimitado: 4,
};

const TIPO_RESPOSTA_NUMERO = 2;

function getFirstDefined(...values) {
  return values.find((value) => value !== undefined && value !== null);
}

function formatDecimal(value) {
  const numberValue = Number(value);
  if (Number.isNaN(numberValue)) return value;

  return numberValue.toLocaleString("pt-BR", {
    maximumFractionDigits: 2,
  });
}

export function getRespostaNumericaInfo(pergunta) {
  const tipoRespostaId = Number(
    getFirstDefined(
      pergunta?.tipoRespostaId,
      pergunta?.tipo_resposta_id,
      pergunta?.tipoRespostaID
    )
  );

  const valorInformado = getFirstDefined(
    pergunta?.valorInformado,
    pergunta?.resposta2,
    pergunta?.Resposta2
  );

  if (
    tipoRespostaId !== TIPO_RESPOSTA_NUMERO ||
    valorInformado === undefined ||
    valorInformado === null ||
    valorInformado === ""
  ) {
    return "";
  }

  const pontos = formatDecimal(getFirstDefined(pergunta?.pontos, 0));
  const pontosPossiveisRaw = getFirstDefined(
    pergunta?.pontosPossiveis,
    pergunta?.pergunta?.pontos
  );
  const pontosPossiveis =
    pontosPossiveisRaw === undefined || pontosPossiveisRaw === null
      ? ""
      : ` / ${formatDecimal(pontosPossiveisRaw)}`;

  return `Resposta informada: ${valorInformado} | Pontuacao: ${pontos}${pontosPossiveis}`;
}

// 1 - Permitir o envio de APENAS 01 arquivo PDF nas perguntaids
// 1, 4, 5, 6, 7, 8, 9, 10, 11, 12, 14, 15

// 2 - Permitir o envio de 01 OU 02 arquivos PDF na perguntaid 13

// 3 - Permitir a quantidade de arquivos PDFs que está descrita OU no campo
// Quantidade de Atendentes Informada no Diagnóstico OU no campo Quantidade Atual de Atendentes(o que for maior) na perguntaid 3

// 4 - Permitir arquivos PDFs ilimitados na perguntaid 2

export function rulesFile(
  perguntaId,
  quantidadeArquivo,
  quantidadeArquivoDadosComplementares,
  valorDiagnostico,
  atualizacaoAtendentes,
  evidenciada = false
) {
  const umArquivo = [1, 4, 5, 6, 7, 8, 9, 10, 11, 12, 14];
  const pergunta3Maior =
    valorDiagnostico > atualizacaoAtendentes
      ? valorDiagnostico
      : atualizacaoAtendentes;

  if (umArquivo.includes(perguntaId)) {
    if (quantidadeArquivo >= 1) {
      return "Essa pergunta só aceita um arquivo";
    }
  } else if (perguntaId == 13) {
    if (
      (quantidadeArquivo >= 2 && !evidenciada) ||
      (evidenciada && quantidadeArquivo >= 3)
    ) {
      return "Essa pergunta só aceita até dois arquivos";
    }
  } else if (perguntaId == 3) {
    if (quantidadeArquivo >= pergunta3Maior) {
      return `Como foram informados ${pergunta3Maior} atendentes, você só poderá enviar até ${pergunta3Maior} arquivos.`;
    }
  }
  return false;
}
